import React from 'react';

// Optional "key numbers" highlight box for data-heavy stories.
const ArticleStats = ({ stats }) => {
  if (!stats || stats.length === 0) return null;

  return (
    <div data-testid="article-stats" className="my-10 rounded-2xl border border-[#e8743b]/25 bg-gradient-to-br from-[#e8743b]/10 to-[#0c1119] p-6 md:p-8">
      <span className="dctv-eyebrow text-[#e8743b]">By the numbers</span>
      <div className="grid sm:grid-cols-3 gap-6 mt-5">
        {stats.map((s) => (
          <div key={s.label} data-testid="article-stat-item">
            <p className="font-serif-dctv text-3xl md:text-4xl font-bold text-white leading-none">{s.value}</p>
            <p className="text-[#9aa3b2] text-[13px] leading-snug mt-2">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticleStats;
